import { Grid } from "@mui/material";
import React from "react";
import { formatOutput } from "../../../utils/computation/analysis";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

function GraphicalSummaryResult({ summary }) {
  console.log(summary);
  return (
    <div>
      <GraphHeader
        column={summary.column}
        dateTime={summary.dateTime}
        title={"Graphical Summary"}
        analysisId={summary.id}
        additionals={{ confidenceLevel: summary.inputs.confindence }}
      />
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
        sx={{ color: "#535353" }}
      >
        <Grid item xs={2} sm={3} md={3}>
          <h4>N</h4>
          <h3>{summary.descriptiveStats.count}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>Mean</h4>
          <h3>{formatOutput(summary.descriptiveStats.mean)}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>StDev</h4>
          <h3>{formatOutput(summary.descriptiveStats.std)}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>Min</h4>
          <h3>{formatOutput(summary.descriptiveStats.min)}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>25th Percentile</h4>
          <h3>{formatOutput(summary.descriptiveStats["25%"])}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>50th Percentile</h4>
          <h3>{formatOutput(summary.descriptiveStats["50%"])}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>75th Percentile</h4>
          <h3>{formatOutput(summary.descriptiveStats["75%"])}</h3>
        </Grid>
        <Grid item xs={2} sm={3} md={3}>
          <h4>Max</h4>
          <h3>{formatOutput(summary.descriptiveStats.max)}</h3>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <h4>95% CI for u</h4>
          <h3>
            {/* {summary.meanConfidenceInterval.map((mci, index) => {
              return index > 0 && formatOutput(mci) + ", ";
            })} */}
            {summary.meanConfidenceInterval}
          </h3>

          <h4>Note: u is the population mean of Column {summary.column}</h4>
        </Grid>

        <Grid item xs={6} sm={6} md={6}>
          <h4>A²</h4>
          <h3>{summary.asquared}</h3>
        </Grid>
        <Grid item xs={6} sm={6} md={6}>
          <h4>P-value</h4>
          <h3>{summary?.pvalue}</h3>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <h3>Probability Distribution</h3>
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>Mean</h4>
          <h3>{summary.asquared}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Mean</h4>
          <h3>{summary?.probabilityDistribution?.mean}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>StDev</h4>
          <h3>{summary?.probabilityDistribution?.stDev}</h3>
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>skewness</h4>
          <h3>{summary?.probabilityDistribution?.skewness}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>kurtosis</h4>
          <h3>{summary?.probabilityDistribution?.kurtosis}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Length</h4>
          <h3>{summary?.probabilityDistribution?.arrayLength}</h3>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <h3>Percentile</h3>
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>Mean</h4>
          <h3>{summary.asquared}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Minimum</h4>
          <h3>{summary?.percentile?.minimum}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>First-Quartile</h4>
          <h3>{summary?.percentile?.["first-quartile"]}</h3>
        </Grid>

        <Grid item xs={3} sm={3} md={3}>
          <h4>Median</h4>
          <h3>{summary?.percentile?.median}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Third-Quartile</h4>
          <h3>{summary?.percentile?.["third-quartile"]}</h3>
        </Grid>
        <Grid item xs={3} sm={3} md={3}>
          <h4>Maximum</h4>
          <h3>{summary?.percentile?.maximum}</h3>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <h4>Median Confidence Interval</h4>
          <h3>{summary?.medianConfidenceInterval}</h3>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <h4>Standard Deviation Confidence Interval</h4>
          <h3>{summary?.standardDeviationConfidenceInterval}</h3>
        </Grid>
      </Grid>

      <ImageGraph
        url={summary.meanConfidenceIntervalBase64}
        title="Mean Confidence Interval"
        column={summary.column}
        // percent={summary.inputs.confindence * 100}
      />
      <ImageGraph
        url={summary.medianConfidenceIntervalBase64}
        title="Median Confidence Interval"
        column={summary.column}
        // percent={summary.inputs.confindence * 100}
      />

      <ImageGraph
        url={summary.boxplot}
        title="BoxPlot"
        column={summary.column}
        percent={summary.inputs.confindence * 100}
      />
      <ImageGraph
        url={summary.histogram}
        title="Histogram"
        column={summary.column}
        percent={summary.inputs.confindence * 100}
      />
    </div>
  );
}

export default GraphicalSummaryResult;
